const calculateTemplateCoulmns = (kind, total) => {
    if (total < 2) {
        return 'auto';
    }
    return kind === 'expanded' ? `1fr repeat(${total}, auto) 1fr` : undefined;
};

export { calculateTemplateCoulmns };
